import { TFunction } from 'core/i18n/i18n';

export const NO_STATUS = 'NO_STATUS';

const FIXED_OPTIONS = [{ id: NO_STATUS, name: 'commons.components.alarm-filter.options.no_status' }];

export const getFixedOptions = (t: TFunction) => FIXED_OPTIONS.map((option) => ({ ...option, name: t(option.name) }));
